import { render, staticRenderFns } from "./CMContactList.vue?vue&type=template&id=9b77d38e&"
import script from "./CMContactList.vue?vue&type=script&lang=js&"
export * from "./CMContactList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b77d38e')) {
      api.createRecord('9b77d38e', component.options)
    } else {
      api.reload('9b77d38e', component.options)
    }
    module.hot.accept("./CMContactList.vue?vue&type=template&id=9b77d38e&", function () {
      api.rerender('9b77d38e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/contacts/CMContactsPage/CMContactList.vue"
export default component.exports